export default [
  {
    id: "frequencyDaily",
    value: "daily",
    label: "Daily",
  },
  {
    id: "frequency3x",
    value: "triweekly",
    label: "3 times a week",
  },
  {
    id: "frequency1x",
    value: "weekly",
    label: "1 time a week",
  },
  {
    id: "frequencyMonthly",
    value: "monthly",
    label: "Monthly",
  },
];
